module.exports = __webpack_public_path__ + "img/HTCC-AC01.da268f2c.jpg";